import { defineAsyncComponent } from 'vue';

export default {
    emits: ['dyt-sort', 'dyt-unfold', 'dyt-action'],
    components: {
        dynamicTable2: defineAsyncComponent(() => import('@/libraries/dynamictable2/index.vue')),
        dyTh2: defineAsyncComponent(() => import('@/libraries/dynamictable2/th.vue')),
    },
    props: {
        dytSortDefault: { type: Array, default: () => [] },
        dytData: { type: Array, default: () => [] },
        dytClass: { type: String, default: '' },
    },
    data: () => ({
        dytnamic_table_unfolded: [],
        dytnamic_table_data_uid_associated: {},
        dytnamic_table_sort: [],
    }),
    created(){ this.dytnamic_table_sort = this.dytSortDefault; },
    methods: {
        dytEmit(action, data){ this.$emit('dyt-action', {action, data}); },

        // Unfold
        dytIsUnfolded(id) { return this.dytnamic_table_unfolded.indexOf(id) > -1; },
        dytUnfold(id, remove_uid_association = false){
            const pos = this.dytnamic_table_unfolded.indexOf(id);
            if (pos > -1){
                this.dytnamic_table_unfolded.splice(pos, 1);
                if(remove_uid_association && this.dytHasUid(id)){
                    this.dytRemoveToUid(id);
                }
                return false;
            }else{
                this.dytnamic_table_unfolded.push(id);
                return true;
            }
        },
        dytForceUnfold(id){
            if(!this.dytIsUnfolded(id)) this.dytnamic_table_unfolded.push(id);
        },
        dytBusy(id){ return this.dytUnfold("busy"+id); },
        dytIsBusy(id){ return this.dytIsUnfolded("busy"+id) },

        // Elements associated to uid
        dytHasUid(uid){ return this.dytnamic_table_data_uid_associated[uid] !== undefined; },
        dytPushToUid(uid, data){ this.dytnamic_table_data_uid_associated[uid] = data; },
        dytRemoveToUid(uid){ delete this.dytnamic_table_data_uid_associated[uid]; },
        dytGetToUid(uid){return this.dytnamic_table_data_uid_associated[uid]; },
        dyGetStartsWith(prefix){ return  Object.keys(this.dytnamic_table_data_uid_associated).filter(k => k.startsWith(prefix)); },

        // Generate sort data
        dytAddToSort(column, reset){
            const pos = this.dytnamic_table_sort.indexOf(column);
            if(pos > -1){
                this.dytnamic_table_sort.splice(pos, 1);
                if(reset) this.dytnamic_table_sort = [];
                this.dytnamic_table_sort.push('-'+column);
            } else {
                const pos = this.dytnamic_table_sort.indexOf('-'+column);
                if(pos > -1){
                    if(reset) this.dytnamic_table_sort = [];
                    else this.dytnamic_table_sort.splice(pos, 1);
                }else{
                    if(reset) this.dytnamic_table_sort = [];
                    this.dytnamic_table_sort.push(column);
                }
            }
            this.$emit('dyt-sort', this.dytnamic_table_sort);
        }
    }
}
